import WishlistButton from '../../../../components/buttons/WishlistButton';

const Wishlist = ({ code, ...props }) => {
    return (
        <WishlistButton code={code} style={{ width: '70px' }} {...props} />
    );
}

export default Wishlist;